import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'horizontal' | 'vertical';
}

export default function ArticleCard({ article, variant = 'vertical' }: ArticleCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group flex flex-col sm:flex-row gap-4 rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline"
      >
        <div className="w-full sm:w-[200px] aspect-[16/9] sm:aspect-[4/3] overflow-hidden flex-shrink-0">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={article.title}
          />
        </div>
        <div className="flex-1 p-3 md:p-4 flex flex-col justify-center">
          <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 font-heading">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 mb-2 line-clamp-2">{article.excerpt}</p>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {article.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.views}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={article.title}
        />
      </div>
      <div className="p-3 md:p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-[10px] rounded-full font-medium">
            {article.category}
          </span>
          {article.featured && (
            <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-[10px] rounded-full font-medium">
              精选
            </span>
          )}
        </div>
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 font-heading">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 mb-2 line-clamp-2">{article.excerpt}</p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{article.author}</span>
          <span>{article.date}</span>
        </div>
      </div>
    </Link>
  );
}